import type { FC } from "react";
import { Link } from "react-router-dom";

import Shell from "../components/Shell";

const PRIVACY_POLICY_URL = "https://www.teamhousing.com/privacy-policy";

const PrivacyPage: FC = () => (
  <Shell>
    <main className="relative z-10 flex flex-1 items-center justify-center px-6 py-10">
      <section className="bc-fade-up w-full max-w-2xl text-center text-white">
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-white/30">
          Team Housing Solutions
        </p>
        <h1 className="mt-4 font-oswald text-4xl font-medium uppercase tracking-wide sm:text-5xl">
          Basecamp Kiosk Privacy & Support
        </h1>

        <div className="mt-8 space-y-5 text-left text-sm leading-6 text-white/70">
          <p>
            This kiosk is used for Team Housing Solutions basecamp lodging
            operations. The kiosk may collect or submit a DOD/EDIPI identifier,
            guest and stay lookup details, email address, mobile number, SMS
            consent preferences, vehicle plate and make, check-in or check-out
            status, inventory responses, and diagnostics needed to operate the
            service.
          </p>
          <p>
            The kiosk does not use third-party advertising or cross-app
            tracking. The kiosk route is designed for shared iPads and does not
            intentionally persist guest tokens or access codes in browser
            storage.
          </p>
          <p>
            The full Team Housing Solutions Privacy Policy is available at{" "}
            <a
              className="font-semibold text-accentGreen underline-offset-4 hover:underline"
              href={PRIVACY_POLICY_URL}
              rel="noreferrer"
              target="_blank"
            >
              Team Housing Solutions Privacy Policy
            </a>
            .
          </p>
          <p>
            Optional lodging texts are described in the{" "}
            <Link className="text-accentGreen underline" to="/sms-terms">
              THS Lodging SMS Terms
            </Link>
            .
          </p>
        </div>

        <div
          id="support"
          className="mt-8 border-t border-white/10 pt-6 text-sm text-white/65"
        >
          <h2 className="font-oswald text-xl font-medium uppercase tracking-wide text-white">
            Support
          </h2>
          <p className="mt-3">
            For app support, contact Team Housing Solutions at
            info@teamhousing.com or 830.609.8855. For privacy questions, contact
            help@teamhousing.com.
          </p>
        </div>

        <Link
          className="mt-8 inline-flex rounded-xl border border-white/[0.15] px-8 py-3 font-oswald text-base font-medium uppercase tracking-wider text-white/80 transition-all hover:border-white/30 hover:text-white active:scale-[0.98]"
          to="/kiosk"
        >
          Return to Kiosk
        </Link>
      </section>
    </main>
  </Shell>
);

export default PrivacyPage;
